/**
 * inCust terminal API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface PriceSpecialAccount {
  /**
   * Active flag
   */
  active?: number | null;
  /**
   * Corporate accoiunt flag
   */
  corporate?: number | null;
  /**
   * Credit limit (only for \'credit\' accounts)
   */
  credit_limit?: number | null;
  /**
   * Credit type (only for corporate accounts)
   */
  credit_type?: PriceSpecialAccount.CreditTypeEnum | null;
  /**
   * Currency ISO code
   */
  currency?: string | null;
  /**
   * Account applicable goods
   */
  goods_items?: Array<string> | null;
  /**
   * Special account id
   */
  id?: string | null;
  /**
   * Title to show
   */
  public_title?: string | null;
  /**
   * Account title
   */
  title?: string | null;
  /**
   * Account type
   */
  type?: PriceSpecialAccount.TypeEnum | null;
  /**
   * The limit of redemption from customer account without an confirmation
   */
  unconfirmed_redeem_amount?: number | null;
}
export namespace PriceSpecialAccount {
  export type CreditTypeEnum = 'debit' | 'credit' | 'credit-unlimited';
  export const CreditTypeEnum = {
    Debit: 'debit' as CreditTypeEnum,
    Credit: 'credit' as CreditTypeEnum,
    CreditUnlimited: 'credit-unlimited' as CreditTypeEnum
  };
  export type TypeEnum = 'money' | 'goods' | 'punches';
  export const TypeEnum = {
    Money: 'money' as TypeEnum,
    Goods: 'goods' as TypeEnum,
    Punches: 'punches' as TypeEnum
  };
}
